export const IconComplete = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="8" cy="8" r="8" fill="white"/>
<g clip-path="url(#clip0_540_1560)">
<path d="M8 0C3.56627 0 0 3.56627 0 8C0 12.4337 3.56627 16 8 16C12.4337 16 16 12.4337 16 8C16 3.56627 12.4337 0 8 0ZM11.2771 6.36145L7.37349 10.2651C7.27711 10.3614 7.18072 10.4096 7.03614 10.4096C6.89157 10.4096 6.79518 10.3614 6.69879 10.2651L4.72289 8.19277C4.53012 8 4.57831 7.71084 4.72289 7.56626C4.91566 7.37349 5.20482 7.42169 5.3494 7.56626L6.98795 9.3012L10.6024 5.68675C10.7952 5.49398 11.0843 5.49398 11.2289 5.68675C11.4699 5.87952 11.4699 6.16867 11.2771 6.36145Z" fill="#6ECD91"/>
</g>
<defs>
<clipPath id="clip0_540_1560">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>

`